module.exports = __webpack_public_path__ + "img/205.8f5f530f.jpg";